import { useCallback, useMemo } from "react";
import DOMPurify from "dompurify";
import { useMediaQuery } from "react-responsive";

import { FLOW_TYPES } from "../../constants/flowType";
import { VISUAL_HELPERS } from "../../utils";
import { useTicketingContext } from "../../store";
import ActivitiesController from "./ActivitiesController";

const AddonsListItem = ({
  addon,
  price,
  currency,
  timeslots = [],
  onSelectAddonTickets,
  isLastElement = false,
}) => {
  const { state } = useTicketingContext();
  const texts = state?.texts || {};
  const flowType = state?.flowType;

  const selectedAddonTickets = state?.summary?.selectedAddonTickets || {};

  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const isAddonActive = useMemo(
    () => timeslots?.some((t) => t?.active === "true"),
    [timeslots]
  );

  const timeRange = useMemo(() => {
    const source =
      flowType === FLOW_TYPES.ACTIVITIES_ONLY
        ? (timeslots?.[0] ? [timeslots[0]] : [])
        : timeslots;
    return VISUAL_HELPERS.displayTimeRangeFromTimeslots(source);
  }, [flowType, timeslots]);

  const priceInCurrency = useMemo(
    () => VISUAL_HELPERS.displayPriceBasedOnCurrency(price, currency),
    [price, currency]
  );

  const hasPrice = Number(priceInCurrency) > 0;

  const initialTimeslot = selectedAddonTickets?.[addon?.id];

  const descriptionHTML = useMemo(
    () => DOMPurify.sanitize(addon?.description || ""),
    [addon?.description]
  );

  const onControlChange = useCallback(
    ({ entry_no, qty }) => {
      onSelectAddonTickets(
        entry_no,
        qty,
        addon?.id,
        price,
        Boolean(addon?.auto_select_timeslot)
      );
    },
    [onSelectAddonTickets, addon?.id, addon?.auto_select_timeslot, price]
  );

  return (
    <div className="addons-list" id={addon?.admission_code}>
      <div className="addons-list-item">
        <div className="addons-list-item-image">
          <img
            alt={addon?.title || "Add-on"}
            src={addon?.image}
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="addons-list-item-content activity-box">
          <h5>{timeRange}</h5>
          <h3>{addon?.title}</h3>

          <div className="description">
            <p dangerouslySetInnerHTML={{ __html: descriptionHTML }} />
          </div>

          {isMobile && isAddonActive ? (
            <div className="price-info">
              <h3>{hasPrice ? `${currency?.name} ${priceInCurrency}` : texts?.common?.free}</h3>
              <span>{hasPrice ? texts?.common?.per_person : ""}</span>
            </div>
          ) : null}

          <ActivitiesController
            addon={addon}
            addonId={addon?.id}
            initialTimeslot={initialTimeslot}
            isLastElement={isLastElement}
            onControlChange={onControlChange}
            selectedAddonTickets={selectedAddonTickets}
            timeslots={timeslots}
          />

          <div className="addons-list-item-footer">
            {!isMobile && isAddonActive ? (
              <div className="price-info">
                <h3>{hasPrice ? `${currency?.name} ${priceInCurrency}` : texts?.common?.free}</h3>
                <span>{hasPrice ? texts?.common?.per_person : ""}</span>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddonsListItem;
